import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { getPrescriptionService } from '../../../domains/prescriptions';

/**
 * 복약지도문 조회 hook.
 *
 * @param ediCodes EDI 9자리 코드 배열 (빈 배열이면 호출 안 함)
 * @returns React Query result. data는 medications 배열.
 */
export const useMedicationGuide = (ediCodes: string[] | null | undefined) => {
  // 키 안정성을 위해 정렬 + dedup
  const normalized = useMemo(() => {
    if (!Array.isArray(ediCodes)) return [];
    return Array.from(new Set(ediCodes.filter(Boolean))).sort();
  }, [ediCodes]);

  return useQuery({
    queryKey: ['medication-guide', normalized],
    enabled: normalized.length > 0,
    queryFn: async () => {
      const service = getPrescriptionService();
      const res = await service.getMedicationGuide(normalized);
      const meds = res?.data?.medications ?? res?.medications ?? [];
      return meds as Array<Record<string, unknown>>;
    },
  });
};
